var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_888_11614",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_888_11614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.375 21.6C7.125 21.35 7 21.0542 7 20.7125C7 20.3708 7.125 20.075 7.375 19.825L14.7 12.5L7.35 5.15C7.11667 4.91667 7 4.625 7 4.275C7 3.925 7.125 3.625 7.375 3.375C7.625 3.125 7.92083 3 8.2625 3C8.60417 3 8.9 3.125 9.15 3.375L17.55 11.8C17.65 11.9 17.7208 12.0083 17.7625 12.125C17.8042 12.2417 17.825 12.3667 17.825 12.5C17.825 12.6333 17.8042 12.7583 17.7625 12.875C17.7208 12.9917 17.65 13.1 17.55 13.2L9.125 21.625C8.89167 21.8583 8.60417 21.975 8.2625 21.975C7.92083 21.975 7.625 21.85 7.375 21.6Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.b29accce4f240b58aa5bef9615377ce8.svg";
export { ForwardRef as ReactComponent };